import i18n from "i18next";
import React from "react";
import { ResponsiveImage } from "../components/ResponsiveImage.component";
import { ImageAssetInterface } from "../decoders/PubSub.types";
import { generateImageAssetSizes, placeholderImage } from "../lib/image";
import { MagicLink } from "../ui";

export const ImageAsset = (props: ImageAssetInterface) => {
    const caption = props.use_caption && props.caption ? props.caption : null;
    const altText = props.title || props.alt_text || "";
    const { srcset, sizes } = generateImageAssetSizes(props.imgUrl);
    const placeholderSrc = `${placeholderImage}?ops=resize(900,506),quality(10)`;

    return (
        <figure className="component-image-asset">
            {props.counter ? <section className="image-counter">{props.counter}</section> : null}
            <section className="image-container">
                {props.url ? (
                    <MagicLink to={props.url} target={props.new_tab ? "_blank" : "_self"}>
                        <ResponsiveImage
                            src={placeholderSrc}
                            placeholder={placeholderSrc}
                            alt={altText}
                            srcset={srcset}
                            sizes={sizes}
                            initialWidth={288}
                            initialHeight={162}
                        />
                    </MagicLink>
                ) : (
                    <ResponsiveImage
                        src={placeholderSrc}
                        placeholder={placeholderSrc}
                        alt={altText}
                        srcset={srcset}
                        sizes={sizes}
                        initialWidth={288}
                        initialHeight={162}
                    />
                )}
            </section>
            {caption || props.source_credit ? (
                <figcaption>
                    {caption}
                    {props.source_credit ? (
                        <p className="image-credit">
                            {i18n.t("photo")}: {props.source_credit}
                        </p>
                    ) : null}
                </figcaption>
            ) : null}
        </figure>
    );
};

export default ImageAsset;
